/**
 * Archelia Document Prefetching Engine (Amazon-like Architecture)
 * 
 * Strategia V3:
 * Abbandona il prefetch delle singole immagini e adotta il Document Prefetching.
 * Quando l'utente sfiora una card, pre-carica l'intero documento HTML della pagina prodotto.
 * Sfrutta la Speculation Rules API (Chrome/Edge) e un fallback `<link rel="prefetch">` per Safari.
 */

document.addEventListener('DOMContentLoaded', () => {
  const prefetchedUrls = new Set();
  const supportsSpeculationRules = HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules');

  // Funzione per eseguire il prefetch di un documento (URL)
  const prefetchDocument = (url) => {
    if (!url || prefetchedUrls.has(url)) return;
    prefetchedUrls.add(url);

    if (supportsSpeculationRules) {
      // Metodo moderno (Chrome/Edge)
      const script = document.createElement('script');
      script.type = 'speculationrules';
      const rules = {
        prefetch: [
          {
            source: 'list',
            urls: [url]
          }
        ]
      };
      script.textContent = JSON.stringify(rules);
      document.head.appendChild(script);
    } else {
      // Fallback tradizionale (Safari / Firefox)
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = url;
      link.as = 'document'; // Indica al browser di trattarlo come priorità bassa di navigazione
      document.head.appendChild(link);
    }
  };

  // Inizializza una singola card per il prefetch su Hover
  const initCard = (card) => {
    if (card.dataset.smartPrefetchInit === 'true') return;
    card.dataset.smartPrefetchInit = 'true';

    const handleIntent = () => {
      const targetUrl = card.dataset.prefetchUrl;
      if (targetUrl) {
        prefetchDocument(targetUrl);
      }
    };

    // Scatena al passaggio del mouse o al primo tocco
    card.addEventListener('mouseenter', handleIntent, { once: true, passive: true });
    card.addEventListener('touchstart', handleIntent, { once: true, passive: true });
  };

  // Trova e inizializza tutte le product card presenti all'avvio
  const cards = document.querySelectorAll('[data-smart-prefetch="true"]');
  cards.forEach(initCard);

  // MutationObserver per supportare paginazione AJAX, filtri Dawn o Infinite Scroll
  if (window.MutationObserver) {
    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) { // Node.ELEMENT_NODE
              if (node.getAttribute('data-smart-prefetch') === 'true') {
                initCard(node);
              }
              const innerCards = node.querySelectorAll('[data-smart-prefetch="true"]');
              innerCards.forEach(initCard);
            }
          });
        }
      });
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
});
